
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';

import ExtraFiltersCollapse from '../ExtraFiltersCollapse';
import Filter from '../../../../Filter';
import Rule from '../Rule';

import styles from './styles.js';

const Fieldset = ({
    classId,
    expandedGroups,
    filterGroup,
    filterGroupCollectionIndex,
    filterGroupIndex,
    handleFilterChange,
    handleExpand,
    handleExpanded,
    isFullScreenPanel,
    lang
}) => {
    const { filters, title } = filterGroup;
    return (
        <fieldset>
            <div>
                <legend>
                    <span className={css(styles.text)}>
                        <span>
                            {filterGroup.title}
                        </span>
                    </span>
                </legend>
                <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                    <div className={css(styles.row, styles.rowCondensed)}>
                        {filters.map((filter, index) => {
                            if (index <= 3) {
                                return (
                                    <Filter
                                        key={shortid.generate()}
                                        columns={filterGroup.columns}
                                        filter={filter}
                                        filterIndex={index}
                                        filterGroup={filterGroup}
                                        filterGroupCollectionIndex={filterGroupCollectionIndex}
                                        filterGroupIndex={filterGroupIndex}
                                        handleFilterChange={handleFilterChange}
                                        lang={lang}
                                        noContainer
                                    />
                                );
                            }
                        })}
                    </div>
                    {
                        filters ?
                            filters.length > 4 ?
                                <ExtraFiltersCollapse
                                    classId={classId}
                                    collapseText={filterGroup.collapseText}
                                    expandedGroups={expandedGroups}
                                    expandText={filterGroup.expandText}
                                    filterGroupIndex={filterGroupIndex}
                                    handleExpand={handleExpand}
                                    handleExpanded={handleExpanded}
                                    isExpanded={expandedGroups.filter(
                                        i => Number(i.index) === Number(filterGroupIndex)
                                    ).length}
                                    extraFilters={
                                        filters.map((filter, index) => {
                                            if (index > 3) {
                                                return (
                                                    <Filter
                                                        key={shortid.generate()}
                                                        columns={filterGroup.columns}
                                                        filter={filter}
                                                        filterIndex={index}
                                                        filterGroup={filterGroup}
                                                        filterGroupCollectionIndex={filterGroupCollectionIndex}
                                                        filterGroupIndex={filterGroupIndex}
                                                        handleFilterChange={handleFilterChange}
                                                        lang={lang}
                                                        noContainer
                                                    />
                                                );
                                            }
                                        })
                                    }
                                    isFullScreenPanel={isFullScreenPanel}
                                    title={title}
                                /> : null :
                            null
                    }
                </div>
                <Rule />
            </div>
        </fieldset>
    );
};

Fieldset.defaultProps = {
    isFullScreenPanel: false
};

Fieldset.propTypes = {
    classId: PropTypes.number.isRequired,
    expandedGroups: PropTypes.array.isRequired,
    filterGroup: PropTypes.object.isRequired,
    filterGroupCollectionIndex: PropTypes.number.isRequired,
    filterGroupIndex: PropTypes.number.isRequired,
    handleExpand: PropTypes.func.isRequired,
    handleExpanded: PropTypes.func.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    isFullScreenPanel: PropTypes.bool,
    lang: PropTypes.object.isRequired
};

export default Fieldset;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Fieldset/Fieldset.jsx